// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-home-js": () => import("./../src/templates/Home.js" /* webpackChunkName: "component---src-templates-home-js" */)
}

